import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { SummaryInfoDto } from 'src/app/web/interfaces/project/list/summaryInfoDto';
import { createProjectStage } from '../../../interfaces/project/stages/create/createProjectStage';
import { FormBuilder, FormGroup } from '@angular/forms';
import { infoProjectStage } from '../../../interfaces/project/stages/infoProjectStage';
import { formatDate } from '@angular/common';
import { updateProjectStage } from '../../../interfaces/project/stages/updateProjectStage';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

class weeklyCreate {
  projects_id:number
  percent_planned:number
  percent_real:number
  date:string
  username:string}
class weeklyUpdate {
  id:number
  projects_id:number
  percent_planned:number
  percent_real:number
  date:string
  username:string}

@Component({
  selector: 'app-project-stages-create',
  templateUrl: './weekly-create.component.html',
  styleUrls: ['./weekly-create.component.scss'],
})
export class WeeklyCreateComponent
  implements AfterViewInit, OnDestroy, OnInit{
  idProject: number;
  idStage: number;
  createweekly:weeklyCreate;
  updateweekly:weeklyUpdate;
  createProjectStage: createProjectStage;
  updateProjectStage: updateProjectStage;
  summaryInfoDto: SummaryInfoDto = {} as SummaryInfoDto;
  private apiService: ApiServiceProject;
  createWeeklyForm: FormGroup;
  infoProjectStage: infoProjectStage;
  title
  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private fb: FormBuilder,
    private errorService:ErrorService
  ) {
    this.route.params.subscribe((params) => {
      this.idProject = params['id'];
    });

    if (this.route.snapshot.url[3]+"" != 'edit') {
      this.titleService.setTitle('PDG - Crear avance semanal');
      this.title = 'PDG - Crear avance semanal'
    } else {
      this.titleService.setTitle('PDG - Editar avance semanal');
      this.title = 'PDG - Editar avance semanal'
    }
  }

  ngOnInit(): void {

    this.createWeeklyForm = this.fb.group({
      percent_planned: [''],
      percent_real: [''],
      date: [''],
    });
    this.apiService = new ApiServiceProject(this.http);
    
    this.summaryInfoDto.title = localStorage.getItem("title");

    if (this.route.snapshot.url[3]+"" == 'edit') {

      let dato = JSON.parse(localStorage.getItem("info-mtn"));

      this.idStage = dato.id

      this.createWeeklyForm.patchValue({
        percent_planned: dato.percentPlanned,
        percent_real: dato.percentReal,
        date: moment(dato.dateStart, 'DD-MM-YYYY').format("YYYY-MM-DD")
      })
    }
  }

  formSubmit(): void {
    this.spinner.show();
    if (this.createWeeklyForm.value.percent_planned === '' || !(Number(this.createWeeklyForm.value.percent_planned) > -1 )) {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar un porcentaje planeado válido' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    
    if (this.createWeeklyForm.value.percent_real === '' || !(Number(this.createWeeklyForm.value.percent_real) > -1 )) {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar un porcentaje real válido' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createWeeklyForm.value.date === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una fecha' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if (this.route.snapshot.url[3]+"" != 'edit') {

      this.createweekly = new weeklyCreate();

      this.createweekly.projects_id = Number(this.idProject);
      this.createweekly.username="";
      this.createweekly.date = moment(this.createWeeklyForm.value.date).format("DD-MM-YYYY"); 
      this.createweekly.percent_planned = Number(this.createWeeklyForm.value.percent_planned)
      this.createweekly.percent_real = Number(this.createWeeklyForm.value.percent_real)

      this.apiService
        .postService('project-view-progress-create', this.createweekly)
        .subscribe({
          next: (rs: any) => {
            if(rs.message){
              this.spinner.hide();
              Swal.fire({title:rs.message,text: '',icon: 'success',heightAuto: false}).then((dato)=>{
                this.router.navigate(['/pdg/project/list/view', this.idProject]);
              });
            }
            else{
              this.spinner.hide();
              Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });
    } else {

      this.updateweekly = new weeklyUpdate();

      this.updateweekly.id = Number(this.idStage);
      this.updateweekly.percent_planned = Number(this.createWeeklyForm.value.percent_planned)
      this.updateweekly.percent_real = Number(this.createWeeklyForm.value.percent_real)
      this.updateweekly.projects_id = Number(this.idProject)
      this.updateweekly.date = moment(this.createWeeklyForm.value.date).format("DD-MM-YYYY"); 
      this.updateweekly.username = ""
      
      this.apiService
        .putServiceBody('project-view-progress-update', this.updateweekly)
        .subscribe({
          next: (rs: any) => {
            if (rs.code == null) {
              this.spinner.hide();
              Swal.fire({title:'Se actualizo correctamente' ,text: '',icon: 'success',heightAuto: false}).then(()=>{
                this.router.navigate(['/pdg/project/list/view', this.idProject]);
              });
              
            } else {
              this.spinner.hide();
              Swal.fire({
              title:  rs.error,
              text: '',
              icon: 'error',
              heightAuto: false
              });
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });
    }
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  rerender(): void {}
}
